import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import ImageSlidersList
  from 'components/dashboard/image-slider/ImageSlidersList';
import AddImageSlider
  from 'components/dashboard/image-slider/AddImageSlider';

import './ImageSliderContent.css';

const ImageSliderContent = ({ imageSlidersList }) => (
  <Translation>
    {(t) => (
      <DashboardFormSection
        header={t("IMAGE SLIDERS")}
        className="image-slider-content__component"
        noBordered={imageSlidersList && imageSlidersList.length > 0}
        noPadding={imageSlidersList && imageSlidersList.length > 0}
      >
        {imageSlidersList && imageSlidersList.length > 0 &&
          <ImageSlidersList />
        }
        <AddImageSlider />
      </DashboardFormSection>
    )}
  </Translation>
);

ImageSliderContent.propTypes = {
  imageSlidersList: PropTypes.arrayOf(PropTypes.shape),
};

ImageSliderContent.defaultProps = {
  imageSlidersList: null,
};

const mapStateToProps = state => (
  {
    imageSlidersList: state.imageSlidersReducer.imageSlidersList,
  }
);

export default connect(
  mapStateToProps,
  {},
)(ImageSliderContent);
